const store = {
  get(key) {
    if (key === undefined || key === "") {
      return false;
    }

    const item = localStorage.getItem(key);
    const itemPresent =
      item !== null &&
      item !== undefined &&
      item !== "null" &&
      item !== "undefined";

    return itemPresent ? JSON.parse(item) : false;
  },

  set(key, item) {
    localStorage.setItem(key, JSON.stringify(item));
    return true;
  },

  clear(key) {
    return store.set(key, null);
  },

  clearAll() {
    return localStorage.clear();
  },
};

export default store;
